import { AbstractMouseEvent } from './AbstractMouseEvent';
import { WheelDirection } from './MouseLongPressEvent';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class MouseWheelEvent extends AbstractMouseEvent {
  wheelDelta: number;
  direction: WheelDirection;

  constructor(mouse: Mouse, event: CGSMouseEvent, direction: WheelDirection, wheelDelta: number) {
    super(mouse, event);
    this.direction = direction;
    this.wheelDelta = wheelDelta;
  }
}
